module.exports = __webpack_public_path__ + "static/media/success-blue.2fa68503.svg";